// extracted by mini-css-extract-plugin
export var container = "reference-module--container--XMqSA";
export var title = "reference-module--title--PQirP";
export var subTitle = "reference-module--subTitle--lDwZx";